import { AppContext } from 'App'
import React, { useContext } from 'react'
import { Tab } from 'static/tabs'
import { FormContext } from 'components/utils/Form.context'
import { Form as FormHelper } from 'helpers/form'
import { Routing as RoutingHelper } from 'helpers/routing'
import { Reload as ReloadHelper } from 'helpers/reload'
import { Data as DataHelper } from 'helpers/data'
import Accordion from 'components/utils/Accordion/Accordion'
import Container from 'components/utils/GridContainer/GridContainer'
import CTAButton from 'components/utils/Button/CTAButton'
import Table from './Table'
import ReloadButton from 'components/utils/Button/ReloadButton'
import { TeamContext } from 'components/Team/__Team.context'

const TableWithAdd: React.FC = () => {
  const { db, alert } = useContext(AppContext)
  const { params: t_params } = useContext(TeamContext)

  const opt = {
    alert: {
      manager: alert,
      texts: {
        form: Tab.TeamDatasourceIdentifiers,
      },
    },
  }

  const touchAll = async () => {
    if (!db?.gamingGears) return

    await FormHelper.touchAll({
      repository: db.teamDatasourceIdentifiers,
      optional: opt,
    })
  }

  const reload = async () => {
    if (!db?.teamDatasourceIdentifiers) return

    if (t_params?.team_id)
      return await ReloadHelper.reload({
        getAllFn: () => DataHelper.getTeamDatasourceIdentifiersByTeamId(
          db,
          t_params.team_id,
        ),
        optional: opt
      })
  }

  const computeRoutingPath = () => {
    const _routingParams = {
      teamDatasourceIdentifier: RoutingHelper.NewRecordSymbol,
      team: t_params?.team_id ?? RoutingHelper.NewRecordSymbol,
      sport: t_params?.sport_id ?? RoutingHelper.NewRecordSymbol
    }

    if (t_params?.team_id)
      return RoutingHelper.getTeamDatasourceIdentifierDetailUrlFromTeam(
        _routingParams
      )
  }

  return (
    <FormContext.Provider value={{ touch: touchAll }}>
      <Accordion
        content={
          <Container
            items={[
              <CTAButton
                key={'Container.CTA_New'}
                path={computeRoutingPath()}
              >
                New
              </CTAButton>,
              <ReloadButton
              key={'Container.RealoadButton'}
              reloadFn={reload}
              from={opt.alert.texts.form}
            />
          ]}
          />
        }
        toggle={<Table />}
      />
    </FormContext.Provider>
  )
}

export default TableWithAdd
